import { PagePending } from "@/components/ui/PagePending";
import { checkAuth, checkSupplierRole } from "@/utils/router";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/listings/new")({
  pendingComponent: PagePending,
  beforeLoad: async ({ params }) => {
    await checkAuth();
    await checkSupplierRole(params.supplierId);
  },
  component: lazyRouteComponent(() => import("./+NewListing")),
  head: () => ({
    meta: seo({ title: "New Listing" }),
  }),
});
